var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTimerRed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0182 3.55395L18.9191 7.92745C19.1484 9.06587 18.4195 10.1797 17.2811 10.409C16.1427 10.6384 15.0288 9.90945 14.7995 8.77103L13.8986 4.39753C13.6693 3.25911 14.3982 2.14525 15.5366 1.91593C16.675 1.68661 17.7889 2.41553 18.0182 3.55395Z",
    fill: "#313131"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2232 3.24273L13.5958 4.19278C12.744 4.36477 11.9086 3.81603 11.7366 2.96427C11.5646 2.1125 12.1134 1.27711 12.9651 1.10512L17.6007 0.155067C18.4525 -0.0169249 19.2879 0.531811 19.4599 1.38358C19.6319 2.23535 19.0831 3.07074 18.2232 3.24273Z",
    fill: "#C63838"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9406 23.071C32.9406 29.9343 27.3549 35.5117 20.4998 35.5117C13.6447 35.5117 8.05908 29.9261 8.05908 23.071C8.05908 16.2241 13.6447 10.6384 20.4998 10.6384C27.3549 10.6384 32.9406 16.2241 32.9406 23.071Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4999 6.25671C11.2206 6.25671 3.67749 13.808 3.67749 23.071C3.67749 32.3503 11.2287 39.8934 20.4999 39.8934C29.7711 39.8934 37.3223 32.3421 37.3223 23.071C37.3223 13.808 29.7793 6.25671 20.4999 6.25671ZM20.4999 35.5117C13.6366 35.5117 8.05918 29.9261 8.05918 23.071C8.05918 16.224 13.6448 10.6384 20.4999 10.6384C27.355 10.6384 32.9407 16.224 32.9407 23.071C32.9407 29.9342 27.3632 35.5117 20.4999 35.5117Z",
    fill: "#C63838"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0625 21.4297H27.8594C28.6953 21.4297 29.3672 22.1094 29.3672 22.9375C29.3672 23.7734 28.6875 24.4453 27.8594 24.4453H21.0625C20.2266 24.4453 19.5547 23.7656 19.5547 22.9375C19.5547 22.1094 20.2344 21.4297 21.0625 21.4297Z",
    fill: "#313131"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5703 25.9688C22.1322 25.9688 23.3984 24.6151 23.3984 22.9453C23.3984 21.2755 22.1322 19.9219 20.5703 19.9219C19.0084 19.9219 17.7422 21.2755 17.7422 22.9453C17.7422 24.6151 19.0084 25.9688 20.5703 25.9688Z",
    fill: "#ED8103"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimerRed);
export default __webpack_public_path__ + "static/media/timer-red.9baf45268fb41f5d265d9fc2893909d3.svg";
export { ForwardRef as ReactComponent };